import {
  type NotificationContent,
  type NotificationContentModality,
  type NotificationContentSource,
} from 'primary-schema';

import { type UpsertValues as UpsertIntent } from './intent.js';
import { type NullablePartial } from '../common.js';

/** What the editor sends. primary answers with every language's content filled in; a draft need not. */
export type UpsertLocalizationEntry = NullablePartial<{
  content: string;
  subject: string | null;
}>;
export interface UpsertLocalizationMap {
  [language: string]: UpsertLocalizationEntry;
}

export enum EntityKind {
  Encounter = 'ENCOUNTER',
  PatientOrder = 'PATIENT_ORDER',
  EhrInformation = 'EHR_INFORMATION',
}

type BaseContent = Omit<NotificationContent, 'id' | 'created' | 'updated'>;

export type CreateValues = NullablePartial<
  Omit<BaseContent, 'deletedTimestamp' | 'localizations' | 'intents' | 'uniqueName'> & {
    localizations: UpsertLocalizationMap;
    intents: UpsertIntent[];
  }
>;
export type UpdateValues = Partial<
  Omit<BaseContent, 'localizations' | 'intents'> & {
    localizations: UpsertLocalizationMap;
    intents: UpsertIntent[];
  }
>;
export type FindAllOptions = Partial<{
  excludedIds: string[];
  q: string;
  organizationIds: string[];
  kind: NotificationContentModality;
  includeDeleted: boolean;
  source: NotificationContentSource;
  name: string;
}>;

export interface SendTestValues {
  entityKind: EntityKind;
  entityId: string;
  destination: string;
}
export interface SendTestResponse {
  source: NotificationContentSource;
  success: boolean;
  error?: Error;
}

export interface CloneValues {
  newName: string;
}
export interface CloneResponse {
  id: string;
}
